export enum ActionType {
  // FE-only — not sent by the backend
  Normal = 'NORMAL',
  // BE actions
  Prize = 'PRIZE',
  Checkpoint = 'CHECKPOINT',
  Finish = 'FINISH',
  Collectible = 'COLLECTIBLE',
  MoveForward = 'MOVE_FORWARD',
  MoveBack = 'MOVE_BACK',
  ExtraRoll = 'EXTRA_ROLL',
  SkipTurn = 'SKIP_TURN',
}
